import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import karmayogiBanner from "../../images/karmayogi-volunteer-pac2.jpeg";

Modal.setAppElement("#root");

/* ---------- Hook: detect when section is active ---------- */
function useInView({ threshold = 0.25, rootMargin = "0px 0px -15% 0px" } = {}) {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(([entry]) => setActive(entry.isIntersecting), {
      threshold,
      rootMargin,
    });

    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold, rootMargin]);

  return { ref, active };
}

function BecomeVolunteer() {
  const { ref, active } = useInView();

  const AREAS = [
    "⁠Interact with policy makers",
    "⁠Membership drive",
    "Hindu Rajneeti Academy",
    "Alliances & Coalition",
    "⁠HBSJ caucus",
    "⁠Conferences and summits",
    "Social media/ press release / news letters",
    "Content creators / IT services",
    
  ];

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [stateCity, setStateCity] = useState("");
  const [selected, setSelected] = useState("");

  const [errors, setErrors] = useState({});
  const [modalOpen, setModalOpen] = useState(false);

  

  const validate = () => {
  const err = {};

  if (!name.trim()) {
    err.name = "*Name Field Required";
  }

  if (!phone.trim()) {
    err.phone = "*Phone Field Required";
  }

  if (!email.trim()) {
    err.email = "*Email Field Required";
  } else if (!email.includes("@") || !email.includes(".")) {
    err.email = "*Invalid Email";
  }

  if (!stateCity.trim()) {
    err.stateCity = "*State & City Required";
  }

  if (!selected) {
    err.area = "*Select an option";
  }

  setErrors(err);

  return Object.keys(err).length === 0;
};

  const submitForm = async (e) => {
  e.preventDefault();

  if (!validate()) return;

  // Open popup immediately
  setModalOpen(true);

  const data = {
    Name: name,
    Phone: phone,
    Email: email,
    StateCity: stateCity,
    Areas: selected,
  };

  try {
    await fetch(
      "https://sheetdb.io/api/v1/d5frfl9vwoyyw",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data }),
      }
    );

    // Clear form
    setName("");
    setPhone("");
    setEmail("");
    setStateCity("");
    setSelected("");

  } catch (error) {
    console.error(error);
    alert("Error submitting form");
  }
};

  return (
    <>
      <style>{`
        .vol-content{
          opacity: 0;
          transform: translateY(16px);
          filter: blur(6px);
          transition: opacity 650ms ease, transform 650ms ease, filter 650ms ease;
        }
        .vol-content.is-active{
          opacity: 1;
          transform: translateY(0);
          filter: blur(0);
        }

        #become-volunteer .block.color-scheme-4{
          padding-top: 28px;
        }

        .vol-card{
          background: rgba(255,255,255,0.06);
          border: 1px solid rgba(255,255,255,0.12);
          border-radius: 16px;
          padding: 18px;
        }

        .vol-banner-frame{
          position: relative;
          isolation: isolate;
          max-width: 980px;
          margin: 0 auto 16px;
          padding: 9px;
          border-radius: 22px;
          background:
            linear-gradient(135deg, #b46e3c 0%, #fff4b0 28%, #0d3f7d 58%, #b40924 78%, #b46e3c 100%);
          box-shadow:
            0 22px 58px rgba(0,0,0,0.36),
            0 0 0 1px rgba(255,255,255,0.18);
        }

        .vol-banner-frame::before{
          content: "";
          position: absolute;
          inset: -1px;
          border-radius: 23px;
          background: linear-gradient(135deg, rgba(255,244,176,0.38), rgba(180,110,60,0.08), rgba(13,63,125,0.3));
          filter: blur(14px);
          z-index: -1;
        }

        .vol-banner{
          display: block;
          width: 100%;
          height: auto;
          border-radius: 15px;
          border: 1px solid rgba(255,255,255,0.8);
          background: #ffffff;
        }

        .vol-intro{
          max-width: 760px;
          margin: 0 auto 26px;
          color: #222;
          font-size: 18px;
          font-weight: 500;
          line-height: 1.65;
        }
        .vol-intro{
          max-width: 100%;
          margin: 0 auto 26px;
          color: #222;
          font-size: 30px;      /* Increase text size */
          font-weight: 800;
          line-height: 1.2;
          text-align: center;
          white-space: nowrap;  /* Keep text on one line */
        }
          .vol-card input[type="text"]:focus::placeholder{
  opacity: 0;
}
        @media (max-width: 640px){
          #become-volunteer .block.color-scheme-4{
            padding-top: 18px;
          }
          .vol-intro{
          font-size: 20px;
          white-space: normal; /* Allow wrapping on mobile */
        }
          .vol-banner-frame{
            padding: 5px;
            border-radius: 15px;
            margin-bottom: 14px;
          }

          .vol-banner{
            border-radius: 10px;
          }

          .vol-intro{
            margin-bottom: 20px;
            font-size: 16px;
          }
        }

        .vol-card input[type="text"]{
          width: 100%;
          padding: 12px;
          border-radius: 12px;
          border: 1px solid rgba(255,255,255,0.25);
          background: rgba(0,0,0,0.18);
          color: #0c0808ff;
          font-weight: 500;
          font-size: 18px;
        }

        .vol-card input[type="text"]::placeholder{
          color: #0e0808ff;
          opacity: 1;
          font-size: 18px;
        }

        .error{
          display: inline-block;
          margin-top: 6px;
          font-size: 13px;
          color: #dd1212ff;
        }

        .mt-3{ margin-top: 1rem; }
        .mt-4{ margin-top: 1.5rem; }

        /* ===== Checkbox Cards ===== */
        .vol-grid{
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
          margin-top: 10px;
        }
        .popup-send{
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  right: auto !important;
  bottom: auto !important;
  transform: translate(-50%, -50%) !important;

  width: 90vw;
  max-width: 360px;
  margin: 0 !important;
}
        @media (max-width: 520px){
          .vol-grid{ grid-template-columns: 1fr; }
        }

        .vol-check-card{
          position: relative;
          padding: 18px 18px;
          border-radius: 14px;
          border: 1px solid rgba(180,110,60,0.35);
          background: rgba(255,255,255,0.05);
          cursor: pointer;
          transition: all 180ms ease;
          display: flex;
          align-items: center;
          font-weight: 800;
          color: #b46e3c;
          font-size: 15px;
        }

        .vol-check-card input{
          position: absolute;
          opacity: 0;
          pointer-events: none;
        }

        .vol-check-card:hover{
          background: rgba(180,110,60,0.12);
          border-color: #b46e3c;
        }

        .vol-check-card.checked{
          background: rgba(180,110,60,0.22);
          border-color: #b46e3c;
          box-shadow: 0 0 0 1px rgba(180,110,60,0.45);
        }

        .vol-check-card span{
          padding-right: 28px;
          line-height: 1.6;
          font-size: 15px;
        }

        .vol-check-card.checked::after{
          content: "✓";
          position: absolute;
          right: 14px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 16px;
          font-weight: 900;
          color: #b46e3c;
        }

        .popup-overlay{
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.55);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .popup-send{
          position: relative;
          background: #101010;
          border: 1px solid rgba(255,255,255,0.18);
          border-radius: 16px;
          padding: 40px 30px;
          width: min(520px, 92vw);
          color: #f9f9f9e9;
          text-align: center;
          outline: none;
          box-shadow: 0 20px 60px rgba(0,0,0,0.5);
        }
        .block-popup h4{ margin: 6px 0; }

        .close-btn{
          position: absolute;
          right: 14px;
          top: 14px;
          width: 30px;
          height: 30px;
          cursor: pointer;
        }
        .close-btn:before, .close-btn:after{
          content:"";
          position:absolute;
          left: 14px;
          top: 6px;
          width: 2px;
          height: 18px;
          background: #fff;
        }
        .close-btn:before{ transform: rotate(45deg); }
        .close-btn:after{ transform: rotate(-45deg); }
        .contact-btn{
  margin-top: 30px;
  padding: 14px 40px;
  background: #b46e3c;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.contact-btn:hover{
  background: #d4874d;
  transform: translateY(-2px);
}
.volunteer-dropdown{
  width: 100%;
  height: 60px;
  padding: 0 18px;
  border-radius: 14px;
  border: 1px solid rgba(180,110,60,0.4);
  background: rgba(0,0,0,0.2);
  color: #b46e3c;
  font-size: 17px;
  font-weight: 700;
  outline: none;
  cursor: pointer;
  transition: all 0.3s ease;
  appearance: none;
}

.volunteer-dropdown:hover{
  border-color: #d4874d;
}

.volunteer-dropdown:focus{
  border-color: #d4874d;
  box-shadow: 0 0 0 3px rgba(212,135,77,0.2);
}

.volunteer-dropdown option{
  background: #ffffffff;
  color: #0e0a07ff;
  font-size: 20px;           /* bigger option text */
  padding: 16px; 
  font-weight: 700;
}
/* ===== GOLD SHINE TEXT ===== */

.gold-shine{
  font-size: 30px;
  font-weight: 900;
  text-transform: uppercase;
  line-height: 1.5;

  background: linear-gradient(
    90deg,
    #5c3b00 0%,
    #b8860b 20%,
    #ffd700 40%,
    #fff4b0 50%,
    #ffd700 60%,
    #b8860b 80%,
    #5c3b00 100%
  );

  background-size: 300% auto;

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  animation: goldShine 4s linear infinite;

  text-shadow:
    0 0 10px rgba(255,215,0,0.25),
    0 0 20px rgba(255,215,0,0.15);
}

@keyframes goldShine{
  0%{
    background-position: -200% center;
  }
  100%{
    background-position: 200% center;
  }
}
      `}</style>
      
      <section id="become-volunteer" className="single-bg">
        <div className="bg-dark"></div>

        <div className="block color-scheme-4">
          {/* Header */}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <div className="section-sub-title center">
                  <article
                    ref={ref}
                    className={`section-title-body white vol-content ${active ? "is-active" : ""}`}
                  >
                    <div className="vol-banner-frame">
                      <img
                        className="vol-banner"
                        src={karmayogiBanner}
                        alt="Become our Karmayogi volunteer for Americans4Hindus PAC"
                      />
                    </div>
                    <p className="vol-intro">
                      <strong>
                        Join as a Karmayogi and be part of our community celebrations and programs.
                      </strong>
                    </p>
                  </article>
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="vol-card">
                  <form onSubmit={submitForm}>
                    <p>
                      <input
                        type="text"
                        placeholder="Your Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                      {errors.name && <span className="error">{errors.name}</span>}
                    </p>

                    <p>
                      <input
                        type="text"
                        placeholder="Your Phone"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />

                      {errors.phone && (
                        <span className="error">{errors.phone}</span>
                      )}
                    </p>

                    <p>
                      <input
                        type="text"
                        placeholder="Your Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      {errors.email && <span className="error">{errors.email}</span>}
                    </p>
                    
                    <p>
                      <input
                        type="text"
                        placeholder="State & City"
                        value={stateCity}
                        onChange={(e) => setStateCity(e.target.value)}
                      />

                      {errors.stateCity && (
                        <span className="error">{errors.stateCity}</span>
                      )}
                    </p>
                    <h4 className="white mt-3">SELECT YOUR AREA OF VOLUNTEERING
</h4>

                    <div className="mt-3">
                      <select
                        value={selected}
                        onChange={(e) => setSelected(e.target.value)}
                        className="volunteer-dropdown"
                      >
                        <option value="">Select Volunteer Area</option>

                        {AREAS.map((area) => (
                          <option key={area} value={area}>
                            {area}
                          </option>
                        ))}
                      </select>
                    </div>

                    {errors.area && <span className="error">{errors.area}</span>}

                    <div className="text-center mt-2">
                      <input
                        type="submit"
                        className="contact-btn btn-move t2"
                        value="Submit"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* Modal */}
          <Modal
            isOpen={modalOpen}
            onRequestClose={() => setModalOpen(false)}
            className="popup-send"
            overlayClassName="popup-overlay"
          >
            <div className="block-popup">
              
              <h4 className="gold-shine">
                THANK YOU FOR BECOMING OUR KARMAYOGI FOR
                <br />
                AMERICANS4HINDUS-501(C)(4)
              </h4>
              
            </div>

            <span
              onClick={() => setModalOpen(false)}
              className="close-btn"
            ></span>
          </Modal>
        </div>
      </section>
    </>
  );
}

export default BecomeVolunteer;
